import React, { useEffect } from 'react'
import Swal from 'sweetalert2'


export default function PreCancelado() {
    
    useEffect(() => {
        Swal.fire({
            confirmButtonText: 'Cerrar',
            confirmButtonColor: '#f05154',
            icon: 'error',
            html: 'Tu status actual es <b class="text-danger">Pre-Cancelado</b>',
            allowOutsideClick: false,
          }).then((result) => {
            if (result.isConfirmed) {
            }
          })
    }, [])
    
  return (
    <></>
  )
}
